import React from 'react';
import { WordBox, Content } from './style.js';
import Icon from '../Icon/index.js';

function Vocabulary(_a) {
    var word = _a.word, isEditing = _a.isEditing, isSelected = _a.isSelected, onClick = _a.onClick, style = _a.style;
    return (React.createElement(WordBox, { style: style, isEditing: isEditing, isSelected: isSelected, onClick: onClick },
        React.createElement(Content, null, word),
        isEditing && (React.createElement(Icon.State, { style: { position: 'absolute', bottom: '0.8rem', right: '0.8rem' }, styleType: "check", size: "small", color: isSelected ? '#52CF29' : '#DEE2E6' }))));
}

export { Vocabulary as default };
